<template>
  <div class="job-list-editor">
    <el-form ref="form" :model="form" label-width="110px" label-position="left">
      <el-form-item :label="$t('microSite.jobList.title')">
        <el-input v-model="form.title" placeholder=""></el-input>
      </el-form-item>
      <el-form-item :label="$t('microSite.jobList.companyName')">
        <tree-select
          class="job-selector"
          :data="companies"
          :defaultProps="companyProps"
          multiple
          :nodeKey="companyKey"
          :checkedKeys="checkedCompanyIds"
          @popoverHide="popoverHide">
        </tree-select>
      </el-form-item>
      <el-form-item :label="$t('microSite.jobList.jobName')">
        <el-select
          class="job-selector"
          v-model="selectedJobIds"
          multiple
          filterable
          :no-data-text="$t('microSite.jobList.noData')"
          :no-match-text="$t('microSite.jobList.noMatchedData')"
          :placeholder="$t('microSite.jobList.pleaseSelect')">
          <el-option
            v-for="item in jobs"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import editorTemplate from '../editorTemplate'
import { microSiteCommonOption } from '@/utils/quillEditor'
import TreeSelect from '@/components/treeSelect'
import { mapActions } from 'vuex'
import Optional from 'optional-js'
import i18n from '@/i18n'

export default {
  mixins: [editorTemplate],
  data () {
    return {
      quillEditorOption: microSiteCommonOption,
      form: {
        title: null
      },
      companies: null,
      companyProps: {
        children: 'subCompanyList',
        label: 'companyName'
      },
      companyKey: 'companyId',
      checkedCompanyIds: [],
      selectedJobIds: [],
      jobs: null,
      oldSelectedJobs: [],
      rootCompanyId: null
    }
  },
  computed: {
  },
  created () {
    const props = this.renderData.data.props
    this.form.title = props.title
    this.companies = props.companies
    this.checkedCompanyIds = props.checkedCompanyIds
    this.selectedJobIds = [...props.selectedJobIds]
    this.rootCompanyId = props.rootCompanyId
  },
  mounted () {
    this._getCompanyTree()
    this._getCompanyJob(this.checkedCompanyIds)
  },
  methods: {
    ...mapActions('microSite', [
      'getCompanyTree',
      'getCompanyJob'
    ]),
    validateAndUpdateRenderData () {
      let result = false
      this.$refs.form.validate(valid => { result = valid })
      if (!result) {
        return result
      }
      const props = this.renderData.data.props
      props.title = this.form.title
      props.jobIds = this.selectedJobIds
      props.companies = this.companies
      props.checkedCompanyIds = this.checkedCompanyIds
      props.selectedJobIds = [...this.selectedJobIds]
      props.rootCompanyId = this.rootCompanyId
      this.updateConfigInRoot()
      return true
    },
    popoverHide (checkedIds, checkedData) {
      this.checkedCompanyIds = checkedIds
      this._getCompanyJob(checkedIds)
    },
    // selectAll (val) {
    //   const allJobs = []

    //   for (const job of this.jobs) {
    //     allJobs.push(job.id)
    //   }

    //   const oldVal = this.oldSelectedJobs.length === 1 ? this.oldSelectedJobs[0] : []

    //   if (val.includes(-1)) {
    //     this.selectedJobIds = allJobs
    //   }

    //   if (oldVal.includes(-1) && !val.includes(-1)) {
    //     this.selectedJobIds = []
    //   }

    //   if (oldVal.includes(-1) && val.includes(-1)) {
    //     const index = val.indexOf(-1)
    //     val.splice(index, 1)
    //     this.selectedJobIds = val
    //   }

    //   if (!oldVal.includes(-1) && !val.includes(-1)) {
    //     if (val.length === allJobs.length - 1) {
    //       this.selectedJobIds = [-1].concat(val)
    //     }
    //   }

    //   this.oldSelectedJobs[0] = this.selectedJobIds
    // },
    async _getCompanyTree () {
      this.companies = Optional.ofNullable(await this.getCompanyTree()).map(item => item).orElse({})
      this.rootCompanyId = this.companies[2].companyId
    },
    async _getCompanyJob (companyIds) {
      this.jobs = Optional.ofNullable(await this.getCompanyJob(companyIds)).map(item => item).orElse({})

      if (this.jobs !== null && this.jobs.length > 0) {
        this.jobs.unshift({ id: -1, title: i18n.t('microSite.jobList.selectAll') })
      }
    }
  },
  components: {
    TreeSelect
  }
}
</script>

<style lang="scss" scoped>
.job-list-editor {
  ::v-deep .quill-editor {
    font-size: 14px;
    line-height: normal;

    div, input {
      font-size: 14px;
    }
  }

  .job-selector {
    width: 100%;
    ::v-deep {
      .el-select {
        width: 100% !important;
      }
    }
  }
}
</style>
